import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LargeNumberFormatPipe } from "./large-number-format.pipe";
import { RatingRoudingPipe } from "./rating-rouding.pipe";
import { SincePipe } from "./since-pipe";
import { UppercaseSplitPipe } from "./uppercase-split.pipe";
import { NameInputTravelKitPipe } from "./name-input-travel-kit";

@NgModule({
  imports: [CommonModule],
  declarations: [
    LargeNumberFormatPipe,
    RatingRoudingPipe,
    SincePipe,
    UppercaseSplitPipe,
    NameInputTravelKitPipe,
  ],
  providers: [],
  exports: [
    LargeNumberFormatPipe,
    RatingRoudingPipe,
    SincePipe,
    UppercaseSplitPipe,
    NameInputTravelKitPipe,
  ],
})
export class SharedPipeModule {}
